import React, { useCallback, useRef } from "react";
import { Alert, Button, Dialog, DialogActions, DialogTitle, Modal, Snackbar, Fade } from "@mui/material";
import { createContext, useState } from "react"
import loader from '@/assets/images/back-trans.svg';

const LoaderContext = createContext()
let confirmCallback = null;
const images = [];

const ProgressLoader = ({ children }) => {

  const [open, setOpen] = useState(false);
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const [confirmDialogMessage, setConfirmDialogMessage] = useState('');
  const [snackBarOpen, setSnackBarOpen] = useState(false);
  const [snackBarMsg, setSnackBarMsg] = useState({
    text: "",
    type: "error",
  });

  const requestCount = useRef(0);

  const showProgress = useCallback(() => {
    requestCount.current += 1;
    setOpen(true);
  }, []);

  const hideProgress = useCallback(() => {
    requestCount.current -= 1;
    if (requestCount.current <= 0) {
      setOpen(false);
      requestCount.current = 0;
    }
  }, []);

  const showToast = (type, message) => {
    setSnackBarMsg({
      text: message,
      type: type,
    });
    setSnackBarOpen(true);
  }

  const handleSnackBarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackBarOpen(false);
  };

  const showConfirmDialog = (message, callback) => {
    setConfirmDialogOpen(true);
    setConfirmDialogMessage(message);
    confirmCallback = callback;
  }

  const handleConfirm = () => {
    setConfirmDialogOpen(false);
    if (confirmCallback) {
      confirmCallback();
      confirmCallback = null;
    }
  }

  const handleConfirmDialogClose = () => {
    setConfirmDialogOpen(false);
  }


  ////////////////////////////////////////////////
  /////////////////// Image //////////////////////
  ////////////////////////////////////////////////

  const addImage = (url, data) => {
    images.push({ url, data })
  }

  const getImage = (url) => {
    for (const image of images) {
      if (image.url === url) {
        return image.data
      }
    }
    return null;
  }

  return (
    <LoaderContext.Provider value={{
      showProgress,
      hideProgress,
      showToast,
      showConfirmDialog,
      addImage,
      getImage,
    }}>{children}
      <Modal
        aria-labelledby="spring-modal-title"
        aria-describedby="spring-modal-description"
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: "#000"
        }}
        open={open}
      >
        <Fade in={open} timeout={300}>
          <div style={{ backgroundColor: "#000", outline: 0 }}>
            <img src={loader} alt="" style={{ width: '100px', height: '100px' }} />
          </div>
        </Fade>
      </Modal>
      <Dialog
        open={confirmDialogOpen}
        onClose={handleConfirmDialogClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {confirmDialogMessage}
        </DialogTitle>
        <DialogActions>
          <Button onClick={handleConfirmDialogClose}>Cancel</Button>
          <Button
            onClick={() => {
              handleConfirm();
            }}
            autoFocus
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>
      <Snackbar
        open={snackBarOpen}
        autoHideDuration={6000}
        onClose={handleSnackBarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={handleSnackBarClose}
          severity={snackBarMsg.type}
          sx={{ width: "100%" }}
        >
          {snackBarMsg.text}
        </Alert>
      </Snackbar>
    </LoaderContext.Provider>
  );
};

export { LoaderContext, ProgressLoader }
